import { useCallback, useMemo, useState, useRef, useEffect } from 'react'
import { ApplicationStep3, TenancyInCommon } from '../../../models/classes/ApplicationStep3.class';
import { InfoCard } from '../../../components/info';
import { P2Button, P2TextDescription, P2TextInput, P2Alert } from 'react-bootstrap-common-script';
import { isArray } from 'lodash';
import { HDBLinks } from '../../../utils/shared/links';
import { HoldingTypeEnum } from '../../../models/enum/holding-type.enum';

interface TenancyInCommonCardProps{
  ConveyancingSetFormValue:(value:any)=>void;
  ConveyancingValue:ApplicationStep3;
  ConveyancingErrors?: any;
  forceError?: boolean;
}
function TenancyInCommonCard({...props}:TenancyInCommonCardProps) {
  const [saveAlertShow, setSaveAlertShow] = useState<boolean>(false);
  const divRef = useRef<any>();
  const isBtnEnable = useMemo(()=>{
    if(props.ConveyancingErrors?.tenancy_in_common){
      try{
        return props.ConveyancingErrors?.tenancy_in_common.every((e:any)=>e.shares?.isValid) && props.ConveyancingErrors?.total_shares?.isValid;
      }
      catch(e){
        return false;
      }
    }
    else{
      return false;
    }
  },[props.ConveyancingErrors])


  const handleTenancyInCommonValue = useCallback((tenancy:TenancyInCommon)=>(value:string)=>{
    let processedValue = value.replace(/[^\d]+/g, "");
      let tempTenancy = props.ConveyancingValue.tenancy_in_common;
      let temp = tempTenancy?.map( tempTenancy =>{
        if(tenancy.user?.myinfo?.uinfin === tempTenancy.user?.myinfo?.uinfin){
          return new TenancyInCommon({...tenancy,shares : Number(processedValue) !== 0 ? processedValue : ""});
        }
        else{
          return tempTenancy;
        }
      })
      props.ConveyancingSetFormValue({...props.ConveyancingValue, tenancy_in_common: temp})
  },[props])

  const handleTenancyInCommonConfirm = useCallback(()=>{
    if(!props.ConveyancingValue.is_holding_type_confirm){
      setSaveAlertShow(false);
    }
    props.ConveyancingSetFormValue({...props.ConveyancingValue, is_holding_type_confirm: !props.ConveyancingValue.is_holding_type_confirm});
  },[props])

  const handleClickOutside = useCallback((event:any) => {

    if(props.ConveyancingValue.holding_type === HoldingTypeEnum.tenancy_in_common
      && !props.ConveyancingValue.is_holding_type_confirm && 
      divRef.current && !divRef.current.contains(event.target)
      ){
          setSaveAlertShow(true);
      }

  },[props, divRef]);

  useEffect(() => {
    // Add click event listener to the document
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); 

  return (
    <div ref={divRef}>
      <InfoCard style={{backgroundColor:"#FFF"}} title={"Tenancy-in-common"} description={<div style={{marginTop:32}}>
          <P2TextDescription description_size={"1.125rem"} description={<p style={{fontSize:"1.125rem"}}>Under <a rel="noopener noreferrer" href={HDBLinks.tenancy_in_common} target="_blank" className="polymer-text-links">tenancy-in-common</a>, each co-owner holds a separate and distinct share in the flat. Upon the demise of a co-owner, their interest in the flat will be distributed according to their Will (if any). If there is no Will, their interest in the flat will be distributed to the beneficiaries in accordance with the provisions of the Intestate Succession Act.</p>}/><P2TextDescription description_size={"1.125rem"} />
          <P2TextDescription description_size={"1.125rem"} description_margin={"2rem 0"}description={"Please specify the number of shares for the proposed owners."}/><P2TextDescription description_size={"1.125rem"} />
          {props.ConveyancingValue.tenancy_in_common?.map( (tenancy, _index) =>{
            let isValid = isArray(props.ConveyancingErrors?.tenancy_in_common) ? !props.ConveyancingErrors?.tenancy_in_common[_index]?.shares?.isValid : false;
            let message = isArray(props.ConveyancingErrors?.tenancy_in_common) ? (props.ConveyancingErrors?.tenancy_in_common[_index]?.shares?.message ?? "Please fill the number of shares") : "";
            const id = `tenancy_in_common_${_index}`;
            return (
              <div key={id} style={{ marginTop: 24 }}>
                <P2TextInput forceError={props.forceError} autoComplete={false} disabled={props.ConveyancingValue.is_holding_type_confirm} isError={isValid} errorMsg={message} required value={tenancy?.shares?.toString()} name='uinfin' maxLength={3} label={`${tenancy.user?.myinfo?.name}'s shares`} placeholder={"1"} type='text' onChange={handleTenancyInCommonValue(tenancy)}/>  
              </div>
            )
          })}
         {!props.ConveyancingErrors?.total_shares?.isValid && 
          <div style={{ marginTop: 24 }}>
            <P2Alert variant={"danger"} text={"Please indicate the number of shares the owners will be holding in whole numbers. Total should add up to 999 as a maximum."}></P2Alert>
          </div>}
          {saveAlertShow && <div style={{ marginTop: 24 }}>
            <P2Alert variant={"danger"} text={"Please confirm the manner of holding type before proceeding."}></P2Alert>
          </div>}
          <div style={{display:"flex", justifyContent:"flex-start", margin:"32px 0 12px"}} className="polymer-button-wrapper">
            <P2Button disabled={!isBtnEnable} onClick={handleTenancyInCommonConfirm} variant={"outline-primary"}>{props.ConveyancingValue.is_holding_type_confirm ? "Edit holding type" :"Confirm holding type"}</P2Button>
          </div>
        </div>} />
      </div>
  )
}

export default TenancyInCommonCard